export const dashboardViewTypes = {
  returns: 'returns',
  shipments: 'shipments',
}
